import { Flex, theme, Typography } from 'antd'

const { Text } = Typography
export const Conditions = () => {
    const {
        token: { colorText }
    } = theme.useToken()
    return (
        <Flex vertical gap={'small'} style={{ maxHeight: 'calc(100vh - 380px)', overflow: 'auto' }}>
            <Text style={{ fontSize: 17, color: colorText }}>
                Добро пожаловать в нашу реферальную программу! Здесь вы сможете не только делиться полезным инструментом
                с друзьями, но и получать достойное вознаграждение за их активность. Вот как это работает:
            </Text>
            <Text style={{ margin: '5px 0', fontSize: 17, color: colorText, fontWeight: 600 }}>
                1. Как работает программа?
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                <b>Шаг 1:</b> Получите вашу уникальную реферальную ссылку в разделе Моя статистика.
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                <b>Шаг 2:</b> Отправьте эту ссылку друзьям, коллегам или опубликуйте её в своих социальных сетях.
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                <b>Шаг 3:</b> Когда приглашённые пользователи регистрируются и оформляют подписку через вашу ссылку, вы
                начинаете получать вознаграждение
            </Text>
            <Text style={{ margin: '5px 0', fontSize: 17, color: colorText, fontWeight: 600 }}>
                2. Сколько я могу заработать?
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                Первые 3 месяца после регистрации вашего приглашённого друга вы получаете 50% от стоимости его подписки.
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                Следующие 3 месяца вознаграждение составляет 30% от его подписки.
            </Text>
            <Text style={{ fontSize: 17, color: colorText, fontWeight: 600 }}>Пример:</Text>
            <Text style={{ fontSize: 17, color: colorText }}>Если ваш друг оформил подписку на 1000 ₽:</Text>
            <Text style={{ fontSize: 17, color: colorText }}>В первые 3 месяца вы получите 500 ₽.</Text>
            <Text style={{ margin: '5px 0', fontSize: 17, color: colorText, fontWeight: 600 }}>
                3. Как использовать заработанные средства?
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                <b>Для подписки:</b> Вы можете использовать свои средства для оплаты подписки на TelegaPlan.
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                <b>Для вывода:</b> Доступен вывод средств на ваш счёт при накоплении суммы от 1000 ₽. Вывод
                осуществляется в разделе Управление средствами.
            </Text>
            <Text style={{ margin: '5px 0', fontSize: 17, color: colorText, fontWeight: 600 }}>
                4. Дополнительные условия
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                1. Вознаграждение начисляется автоматически после оплаты подписки приглашённым пользователем.
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                2. В случае возврата или отмены подписки начисления будут пересчитаны.
            </Text>
            <Text style={{ fontSize: 17, color: colorText }}>
                3. Один пользователь не может быть приглашён повторно, если он уже зарегистрирован в системе.
            </Text>
        </Flex>
    )
}
